// @flow

import type { DialogStateProps } from '@gandi/ui';

import { useAppSelector } from 'src/hooks/useAppSelector';

import { selectProvidedResultsByAvailability } from '../../../modules/selectors/results';
import { AvailableRow } from '../components/AvailableRow';
import { useDomainBundle } from '../modules';

type Props = {
  phasesDialogState: DialogStateProps,
};

export function AvailableDomains({
  phasesDialogState,
}: Props): Array<React.MixedElement> {
  const { bundle } = useDomainBundle();

  const { available } = useAppSelector(selectProvidedResultsByAvailability);

  return available.map(({ fqdn }) => {
    const hasBundle = bundle?.content.includes(fqdn);

    return (
      <AvailableRow
        key={fqdn}
        fqdn={fqdn}
        hasBundle={hasBundle}
        phasesDialogState={phasesDialogState}
      />
    );
  });
}
